import React, { useContext } from 'react';
import cx from 'classnames';

import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import { ModalIdContext } from './Modal';

import stylesheet from './Modal.css';

export type ModalHeroHeaderProps = {
  children?: React.ReactNode;
  className?: string;
  subtitle?: React.ReactNode;
};

const ModalHeroHeader = ({
  children,
  className,
  subtitle,
  ...rest
}: ModalHeroHeaderProps) => {
  const id = useContext(ModalIdContext);
  const isRedesigned = mcdsFlagCheck(
    'xp_mcds_redesign_components_organisms_part_2',
  );

  return (
    isRedesigned && (
      <div className={cx(stylesheet.heroHeader, className)} {...rest}>
        {/* @ts-expect-error TS(2322) FIXME: Type 'unknown' is not assignable to type 'string |... Remove this comment to see the full error message */}
        <h1 id={id} className={stylesheet.title}>
          {children}
        </h1>
        {subtitle && <h3 className={stylesheet.subtitle}>{subtitle}</h3>}
      </div>
    )
  );
};

export default ModalHeroHeader;
